import React, { createContext } from "react"
import { noop } from "lodash-es"

import { Account } from "@/services"

export enum EPage {
    Loading = "loading",
    Preview = "preview",
    Lobby = "lobby",
}

export interface IPageProps {
    className?: string
    style?: React.CSSProperties
    onNext?: () => void
}

export enum ESubPage {
    PV = "pv",
    Relic = "relic",
    Enemy = "enemy",
    SP = "sp",
    Game = "game",
    Record = "record",
}

export interface ISubPageProps {
    className?: string
    style?: React.CSSProperties
    visible: boolean
    onExit?: () => void
}

interface IGlobalState {
    user: Account | null
    hasRole: boolean
    currentPage: EPage
    currentSubPage: ESubPage | null
    showRegistry: boolean
    type: string

    show: boolean
    fontSize: number
    bgm: boolean
    assertLoaded: boolean
}

interface IAction {
    type: "updateContext" | "closeSubPage"
    payload?: Partial<IGlobalState>
}

export const initialGlobalState: IGlobalState = {
    user: null,
    hasRole: true,
    currentPage: EPage.Loading,
    currentSubPage: null,
    showRegistry: false,
    type: "rogue_5",

    show: false,
    fontSize: 16,
    bgm: true,
    assertLoaded: false,
}

export const GlobalContext: React.Context<{
    state: IGlobalState
    dispatch: React.Dispatch<IAction>
}> = createContext({
    state: initialGlobalState,
    dispatch: noop,
})

export type IReducer = React.Reducer<IGlobalState, IAction>

export const globalReducer: IReducer = (state, { type, payload }) => {
    const newState = { ...state, ...(payload || {}) }

    switch (type) {
        case "updateContext":
            return newState
        case "closeSubPage":
            return {
                ...newState,
                currentSubPage: null,
            }
        default:
            return state
    }
}
